/**
 * 垂直填充动画
 */
import fvAnimation from './fvAnimation';

export default class fvVerticalFill extends fvAnimation {
    constructor (shape) {
        super(shape, 'fvVerticalFill');
        this.sizeFunction = AsyncFunction('return ' + this.expression);
        this.realMin = AsyncFunction('return ' + this.realMin);
        this.realMax = AsyncFunction('return ' + this.realMax);
        // 设置id
        this.verticalFillDefsID = shape.uuid();
        // 获取背景色
        this.beforFill = shape.color;
        // 添加渐变标签
        this.verticaDefs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        document.getElementById('svgDom').appendChild(this.verticaDefs);
    }

    async run (domObject, value) {
        if (value == false) return;
        // 获取数据
        let size = await this.executionScript(this.sizeFunction);
        let realMinValue = await this.executionScript(this.realMin);
        let realMaxValue = await this.executionScript(this.realMax);
        if (size == -9999 || size == "__defaule" || size == undefined || isNaN(size)) {
            size = 0;
        }
        if (size >= realMaxValue) {
            size = realMaxValue;
        }
        if (size <= realMinValue) {
            size = realMinValue;
        }
        let viewNum = (parseFloat(this.viewMax) - parseFloat(this.viewMin)) * (size - parseFloat(realMinValue)) / (parseFloat(realMaxValue) - parseFloat(realMinValue)) + parseFloat(this.viewMin);
        // 判断参考点
        let y1 = 1;
        let y2 = 0;
        if (this.beginPath != 'down') {
            y1 = 0;
            y2 = 1;
        }
        this.verticaDefs.innerHTML = `<linearGradient id="${this.verticalFillDefsID}" x1="0" y1="${y1}" x2="0" y2="${y2}">
                                        <stop offset="0%" style="stop-color:${this.fillcolor};stop-opacity:1" />
                                        <stop offset="${Math.abs(viewNum)}%" style="stop-color:${this.fillcolor};stop-opacity:1" />
                                        <stop offset="${Math.abs(viewNum) + 1}%" style="stop-color:${this.beforFill};stop-opacity:1" />
                                        <stop offset="${parseFloat(this.viewMax)}%" style="stop-color:${this.beforFill};stop-opacity:1" />
                                    </linearGradient>`;
        domObject.style.fill = `url(#${this.verticalFillDefsID})`;
    }
}



// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvVerticalFill.js